import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorTasks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M18.75 15.5a.75.75 0 0 1-.75.75h-4.6a.75.75 0 0 1 0-1.5H18a.75.75 0 0 1 .75.75ZM10.4 15.7a2.7 2.7 0 1 1-5.4 0 2.7 2.7 0 0 1 5.4 0Zm-1.5 0a1.2 1.2 0 1 0-2.4 0 1.2 1.2 0 0 0 2.4 0Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M5 21.75A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5ZM3.75 19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v14Z"
    />
    <path
      fill="#F7A600"
      d="M11.38 7.364a.75.75 0 1 0-1.06-1.06L7.667 8.954 6.43 7.718a.75.75 0 0 0-1.06 1.06l1.767 1.768a.75.75 0 0 0 1.06 0l3.183-3.182ZM18 9.95a.75.75 0 0 0 0-1.5h-4.6a.75.75 0 0 0 0 1.5H18Z"
    />
  </svg>
);
export default SvgTwoColorTasks;
